export default __webpack_public_path__ + "static/move-columns-e9ae2511b60ebcb6ab5ea3b2cefb8067.mp4";